export const FORTUNE_MUTATION = {
  SET_HISTORY: 'setHistory',
  SET_HAS_HISTORY: 'setHasHistory',
  SET_COUNT: 'setCount',
  SET_CHANNEL_DATA: 'setChannelData',
  SET_RESULT: 'setResult',
  ADD_LOADING: 'addLoading',
  MINUS_LOADING: 'minusLoading',
}
